import d from "react";
import F from "../../../../_virtual/isFunction.js";
import { warn as $ } from "../util/LogUtils.js";
import { isNumber as m } from "../util/DataUtils.js";
import { filterProps as L } from "../util/ReactUtils.js";
import { getCoordinatesOfGrid as H, getTicksOfAxis as V } from "../util/ChartUtils.js";
import { getTicks as D } from "./getTicks.js";
import { CartesianAxis as T } from "./CartesianAxis.js";
import { useChartWidth as M, useChartHeight as K, useOffset as X, useArbitraryXAxis as Y, useYAxisWithFiniteDomainOrRandom as q } from "../context/chartLayoutContext.js";
var J = ["x1", "y1", "x2", "y2", "key"], Q = ["offset"];
function O(t) {
  "@babel/helpers - typeof";
  return O = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, O(t);
}
function I(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function v(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? I(Object(r), !0).forEach(function(i) {
      U(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function U(t, e, r) {
  return e = Z(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Z(t) {
  var e = R(t, "string");
  return O(e) == "symbol" ? e : e + "";
}
function R(t, e) {
  if (O(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var i = r.call(t, e);
    if (O(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function b() {
  return b = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, b.apply(this, arguments);
}
function W(t, e) {
  if (t == null) return {};
  var r = tt(t, e), i, a;
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(t);
    for (a = 0; a < l.length; a++)
      i = l[a], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function tt(t, e) {
  if (t == null) return {};
  var r = {};
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      if (e.indexOf(i) >= 0) continue;
      r[i] = t[i];
    }
  return r;
}
var et = function(e) {
  var r = e.fill;
  if (!r || r === "none")
    return null;
  var i = e.fillOpacity, a = e.x, l = e.y, o = e.width, u = e.height, f = e.ry;
  return /* @__PURE__ */ d.createElement("rect", {
    x: a,
    y: l,
    ry: f,
    width: o,
    height: u,
    stroke: "none",
    fill: r,
    fillOpacity: i,
    className: "recharts-cartesian-grid-bg"
  });
};
function B(t, e) {
  var r;
  if (/* @__PURE__ */ d.isValidElement(t))
    r = /* @__PURE__ */ d.cloneElement(t, e);
  else if (F(t))
    r = t(e);
  else {
    var i = e.x1, a = e.y1, l = e.x2, o = e.y2, u = e.key, f = W(e, J), c = L(f, !1);
    c.offset;
    var n = W(c, Q);
    r = /* @__PURE__ */ d.createElement("line", b({}, n, {
      x1: i,
      y1: a,
      x2: l,
      y2: o,
      fill: "none",
      key: u
    }));
  }
  return r;
}
function it(t) {
  var e = t.x, r = t.width, i = t.horizontal, a = i === void 0 ? !0 : i, l = t.horizontalPoints;
  if (!a || !l || !l.length)
    return null;
  var o = l.map(function(u, f) {
    var c = v(v({}, t), {}, {
      x1: e,
      y1: u,
      x2: e + r,
      y2: u,
      key: "line-".concat(f),
      index: f
    });
    return B(a, c);
  });
  return /* @__PURE__ */ d.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function rt(t) {
  var e = t.y, r = t.height, i = t.vertical, a = i === void 0 ? !0 : i, l = t.verticalPoints;
  if (!a || !l || !l.length)
    return null;
  var o = l.map(function(u, f) {
    var c = v(v({}, t), {}, {
      x1: u,
      y1: e,
      x2: u,
      y2: e + r,
      key: "line-".concat(f),
      index: f
    });
    return B(a, c);
  });
  return /* @__PURE__ */ d.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function nt(t) {
  var e = t.horizontalFill, r = t.fillOpacity, i = t.x, a = t.y, l = t.width, o = t.height, u = t.horizontalPoints, f = t.horizontal, c = f === void 0 ? !0 : f;
  if (!c || !e || !e.length)
    return null;
  var n = u.map(function(h) {
    return Math.round(h + a - a);
  }).sort(function(h, s) {
    return h - s;
  });
  a !== n[0] && n.unshift(0);
  var g = n.map(function(h, s) {
    var w = !n[s + 1], y = w ? a + o - h : n[s + 1] - h;
    if (y <= 0)
      return null;
    var x = s % e.length;
    return /* @__PURE__ */ d.createElement("rect", {
      key: "react-".concat(s),
      y: h,
      x: i,
      height: y,
      width: l,
      stroke: "none",
      fill: e[x],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ d.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, g);
}
function at(t) {
  var e = t.vertical, r = e === void 0 ? !0 : e, i = t.verticalFill, a = t.fillOpacity, l = t.x, o = t.y, u = t.width, f = t.height, c = t.verticalPoints;
  if (!r || !i || !i.length)
    return null;
  var n = c.map(function(h) {
    return Math.round(h + l - l);
  }).sort(function(h, s) {
    return h - s;
  });
  l !== n[0] && n.unshift(0);
  var g = n.map(function(h, s) {
    var w = !n[s + 1], y = w ? l + u - h : n[s + 1] - h;
    if (y <= 0)
      return null;
    var x = s % i.length;
    return /* @__PURE__ */ d.createElement("rect", {
      key: "react-".concat(s),
      x: h,
      y: o,
      width: y,
      height: f,
      stroke: "none",
      fill: i[x],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ d.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, g);
}
var lt = function(e, r) {
  var i = e.xAxis, a = e.width, l = e.height, o = e.offset;
  return H(D(v(v(v({}, T.defaultProps), i), {}, {
    ticks: V(i, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: l
    }
  })), o.left, o.left + o.width, r);
}, ot = function(e, r) {
  var i = e.yAxis, a = e.width, l = e.height, o = e.offset;
  return H(D(v(v(v({}, T.defaultProps), i), {}, {
    ticks: V(i, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: l
    }
  })), o.top, o.top + o.height, r);
}, P = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function ct(t) {
  var e, r, i, a, l, o, u = M(), f = K(), c = X(), n = v(v({}, t), {}, {
    stroke: (e = t.stroke) !== null && e !== void 0 ? e : P.stroke,
    fill: (r = t.fill) !== null && r !== void 0 ? r : P.fill,
    horizontal: (i = t.horizontal) !== null && i !== void 0 ? i : P.horizontal,
    horizontalFill: (a = t.horizontalFill) !== null && a !== void 0 ? a : P.horizontalFill,
    vertical: (l = t.vertical) !== null && l !== void 0 ? l : P.vertical,
    verticalFill: (o = t.verticalFill) !== null && o !== void 0 ? o : P.verticalFill,
    x: m(t.x) ? t.x : c.left,
    y: m(t.y) ? t.y : c.top,
    width: m(t.width) ? t.width : c.width,
    height: m(t.height) ? t.height : c.height
  }), g = n.x, h = n.y, s = n.width, w = n.height, y = n.syncWithTicks, x = n.horizontalValues, C = n.verticalValues, z = Y(), A = q();
  if (!m(s) || s <= 0 || !m(w) || w <= 0 || !m(g) || g !== +g || !m(h) || h !== +h)
    return null;
  var G = n.verticalCoordinatesGenerator || lt, _ = n.horizontalCoordinatesGenerator || ot, j = n.horizontalPoints, k = n.verticalPoints;
  if ((!j || !j.length) && F(_)) {
    var N = x && x.length, E = _({
      yAxis: A ? v(v({}, A), {}, {
        ticks: N ? x : A.ticks
      }) : void 0,
      width: u,
      height: f,
      offset: c
    }, N ? !0 : y);
    $(Array.isArray(E), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(O(E), "]")), Array.isArray(E) && (j = E);
  }
  if ((!k || !k.length) && F(G)) {
    var p = C && C.length, S = G({
      xAxis: z ? v(v({}, z), {}, {
        ticks: p ? C : z.ticks
      }) : void 0,
      width: u,
      height: f,
      offset: c
    }, p ? !0 : y);
    $(Array.isArray(S), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(O(S), "]")), Array.isArray(S) && (k = S);
  }
  return /* @__PURE__ */ d.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ d.createElement(et, {
    fill: n.fill,
    fillOpacity: n.fillOpacity,
    x: n.x,
    y: n.y,
    width: n.width,
    height: n.height,
    ry: n.ry
  }), /* @__PURE__ */ d.createElement(it, b({}, n, {
    offset: c,
    horizontalPoints: j,
    xAxis: z,
    yAxis: A
  })), /* @__PURE__ */ d.createElement(rt, b({}, n, {
    offset: c,
    verticalPoints: k,
    xAxis: z,
    yAxis: A
  })), /* @__PURE__ */ d.createElement(nt, b({}, n, {
    horizontalPoints: j
  })), /* @__PURE__ */ d.createElement(at, b({}, n, {
    verticalPoints: k
  })));
}
ct.displayName = "CartesianGrid";
export {
  ct as CartesianGrid
};
